import React, { createContext, useContext } from 'react';
import ActiveViewScrollManager from './ActiveViewScrollManager';
import { SurveyFormat } from './constants';
import { SurveyFormatProviderProps, UseSurveyFormatReturn } from './types';

const SurveyFormatContext = createContext<UseSurveyFormatReturn | null>(null);

export const useSurveyFormatContext = (): UseSurveyFormatReturn =>
  useContext(SurveyFormatContext) as UseSurveyFormatReturn;

export const SurveyFormatProvider = ({ children, ...context }: SurveyFormatProviderProps): React.ReactElement => {
  const isOQAAT = context.format === SurveyFormat.ONE_QUESTION_AT_A_TIME;
  return (
    <SurveyFormatContext.Provider value={context}>
      {isOQAAT && <ActiveViewScrollManager />}
      <>{children}</>
    </SurveyFormatContext.Provider>
  );
};
